import styled from 'styled-components'
import { clamp } from '@styles/utils/conversion.style'
export const ContentWrapper = styled.div`
  ul {
    ul {
      ${clamp('padding-left', 20, 40)}
    }
    li, p {
      ${clamp('margin-bottom', 10, 20)}
    }
    p br {
      display: none;
    }
  }
  button {
    text-align: left;
  }
`